import { BrowseLevelsLayout } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels";

export default function BrowseLevelsLayoutRoute() {
  return <BrowseLevelsLayout />;
}
